import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface DeployInfo {
  windows_download_url: string // Windows安装包
  pin_code: string // pin码
  team_name: string
  win_server_download_url: string
  windows_server2003_download_url: string
  windows_xp_download_url: string
  macos_download_url: string
  linux_download_map: Record<string, unknown>,
  systems: string[],
  macos_arm64_download_url: string
  macos_amd64_download_url: string
}

@Injectable()
export class PreviewService {
  constructor (private http: Http) {

  }

  fetchDeployInfo (params: { deploy_token: string }) {
    return this.http.post<DeployInfo>('/team/deploy-info/token', params, {
      headers: {
        'X-Cf-TeamID': -1
      }
    })
  }
}
